export default {
    titulo: "Grupo Tigre",
};